import React, { useEffect } from "react";
import { t } from "../../../../dev/helpers/translator";
import { OpenPopup } from "../../../actions/ui";
import Config from "../../../config/main";

export default function balanceTemplate() {
	const { currencyRounding, amountFixedDecimalCount } = Config.main;

	let { showBalance, balance } = this.state,
		{ profile, terminalBalance, dispatch } = this.props,
		userBalance = profile && profile.balance,
		currency = JSON.parse(sessionStorage.getItem("authData")).currency,
		finalBalance =
			(userBalance === undefined ? null : userBalance + "") ||
			(terminalBalance !== undefined
				? terminalBalance !== null
					? terminalBalance
					: balance === null
					? 0
					: balance
				: balance === null
				? 0
				: balance) ||
			0;

	if (currencyRounding && amountFixedDecimalCount) finalBalance = finalBalance.toFixed(currencyRounding);

	return (
		<div className="single-nav-item">
			{Config.main.useLoyalCardBarcode && (
				<div
					className={`loyal-card-wrapper ${this.props.loyalCard ? "delete" : ""}`}
					onClick={() =>
						!this.props.loyalCard && dispatch(OpenPopup("loyalCardInputPopup"))
					}
				>
					<div className="wallet-star">
						<i className="global-icon icon-wallet-star-wallet" />
					</div>
					<p className="loyal-card-text">
						{this.props.loyalCard
							? t(`Member card applied`)
							: t(`Apply Loyalty Card`)}
					</p>
					{this.props.loyalCard ? (
						Config.main.loyalCardRemoveIcon ? (
							<i
								className="global-icon icon-recycle"
								onClick={this.deleteCard}
							/>
						) : (
							<button
								onClick={this.deleteCard}
								className="remove-card-holder"
							>
								{t("Remove card")}
							</button>
						)
					) : null}
				</div>
			)}

			{!Config.disableBalanceInHeader && (
				<p className={`balance-view-terminal`}>
					{Config.main.showBalanceIcon ? (
						<i className="global-icon icon-wallet" />
					) : (
						t("Balance") + ":"
					)}
					<i
						onClick={this.showBalance()}
						className={`balance-view-icon active${showBalance ? "-enabled" : ""}`}
					/>
					<span>
						{Config.useCurrencySymbol
							? Config.main.currency[currency] + finalBalance
							: `${finalBalance} ${currency}`}
						{/* {Config.main.currency[currency]} */}
						{/* {userBalance || (terminalBalance !== undefined ? terminalBalance !== null ? terminalBalance : balance === null ? 0 : balance : balance === null ? 0 : balance)} */}
					</span>
				</p>
			)}
		</div>
	);
}
